// DEV and AWS UAT use the same portal, so this configuration file also applies to AWS UAT environment
// If have defaultOn as true, the layers is turned on by default
// Otherwise, the first layer in the array is turned on

export default function(baseUrl) {
  return {
    elevation: {
      type: "elevation",
      url: `${baseUrl}/DTM/ImageServer`,
    },
    mmsQueryLayer: {
      url: `${baseUrl}/GInfo/SlopeInfo/MapServer`,
      layerId: 44,
      type: `feature`,
      title: `Man Made Slope - Query`,
    },
    basemaps: [
      {
        title: `Survey Basemap`,
        url: `${baseUrl}/Basemap3D/MapServer`,
        type: `tile-image`,
        properties3D: {
          maxScale: 0,
        },
        mode: `3d`,
      },
      {
        title: `Survey Basemap`,
        url: `${baseUrl}/Basemap/MapServer`,
        type: `tile-image`,
        mode: `2d`,
      },
    ],
    overlays: [
      {
        title: `Man Made Slope`,
        url: `${baseUrl}/GInfo/SlopeInfo/MapServer`,
        seq: 0,
        ordered: true,
        transparency: true,
        lyType: `map-image`,
      },
      {
        title: `Ortho Photo`,
        seq: 1,
        ordered: true,
        transparency: true,
        lyType: `group`,
        layers: [
          {
            title: `Year 1963`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho1963/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 1963 (1:1000)`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho1963_1000/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 1973 - 74`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho1973_74/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 1982`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho1982/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 1993`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho1993/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2000`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2000/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2001`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2001/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2003`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2003/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2004`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2004/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2005`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2005/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2007`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2007/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2008`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2008/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          // {
          //   title: `Year 2010`,
          //   Group: `Ortho Photo`,
          //   url:
          //     `${baseUrl}/Ortho/Ortho2010/MapServer`,
          //   layerId: 0,
          //   // has3D: true,
          //   lyType: `tile-image`,
          // },
          {
            title: `Year 2011 LiDAR Photo`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2012Lidar/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2012`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2012/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          // {
          //   title: `Year 2013`,
          //   Group: `Ortho Photo`,
          //   url:
          //     `${baseUrl}/Ortho/Ortho2013/MapServer`,
          //   layerId: 0,
          //   // has3D: true,
          //   lyType: `tile-image`,
          // },
          {
            title: `Year 2014`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2014R/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2015`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2015/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2018`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2018/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2019`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2019/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
          {
            title: `Year 2021`,
            Group: `Ortho Photo`,
            url: `${baseUrl}/Ortho/Ortho2021/MapServer`,
            layerId: 0,
            has3D: true,
            lyType: `tile-image`,
          },
        ].reverse(),
      },
      // {
      //   title: `Satellite Image`,
      //   url: `${baseUrl}/GInfo/XXXX/MapServer`,
      //   seq: 0,
      //   ordered: true,
      //   transparency: false,
      //   lyType: `map-image`,
      // },
      {
        title: `Geological Map`,
        seq: 2,
        ordered: true,
        transparency: true,
        lyType: `group`,
        layers: [
          {
            title: `1st Ed., Before 1995`,
            Group: `Geological Map`,
            url: `${baseUrl}/Overlay/GeologicalMaps/MapServer`,
            layerId: 0,
            seq: 2,
            lyType: `map-image`,
            has3D: true,
          },
          {
            title: `2nd Ed., After 2008`,
            Group: `Geological Map`,
            url: `${baseUrl}/Overlay/newGeologicalMaps/MapServer`,
            layerId: 0,
            seq: 2,
            lyType: `map-image`,
            has3D: true,
          },
          {
            title: `Solid Geology, After 2008`,
            Group: `Geological Map`,
            url: `${baseUrl}/Overlay/newGeologicalMapsSolid/MapServer`,
            layerId: 0,
            seq: 2,
            lyType: `map-image`,
            has3D: true,
          },
        ],
      },
      {
        title: `Slope Gradient`,
        seq: 3,
        ordered: true,
        transparency: true,
        lyType: `group`,
        layers: [
          {
            title: `Slope Gradient LiDAR 5m`,
            Group: `Slope Gradient`,
            url: `${baseUrl}/Overlay/SlopeGradientLiDAR5m/MapServer`,
            layerId: 0,
            seq: 3,
            lyType: `map-image`,
            has3D: true,
          },
          {
            title: `Slope Gradient LiDAR`,
            Group: `Slope Gradient`,
            url: `${baseUrl}/Overlay/SlopeGradientLiDAR/MapServer`,
            layerId: 0,
            seq: 3,
            lyType: `map-image`,
            has3D: true,
          },
        ],
      },
      {
        title: `Ls Frequency Map`,
        url: `${baseUrl}/Overlay/LsFrequencyMap/MapServer`,
        layerId: 0,
        seq: 4,
        ordered: true,
        transparency: true,
        lyType: `map-image`,
        has3D: true,
      },
      {
        title: `SIMAR`,
        url: `${baseUrl}/Overlay/Simar/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
      {
        title: `Land Lot`,
        url: `${baseUrl}/GInfo/iC1000_ginfo/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
      {
        title: `Grid Line`,
        url: `${baseUrl}/Overlay/Grid_LabelMethod/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
      {
        title: `Map Sheet`,
        url: `${baseUrl}/Overlay/GIU1KCellRef/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
      {
        title: `MTR Proposed Protection Area`,
        url: `${baseUrl}/Overlay/MTR_ARP/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
      {
        title: `Hillshade`,
        url: `${baseUrl}/Overlay/Hillshade/MapServer`,
        layerId: 0,
        lyType: `map-image`,
      },
    ],
    layer2D: [],
    layer3D: {},
  };
}
